/* eslint-disable */

var AES = require("crypto-js/aes");
var SHA256 = require("crypto-js/sha256");
var CryptoJS = require("crypto-js");
import CONSTANT from './Constant';
import firebase from 'firebase'

export default class Utils {

    static WEEKS = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
    static MONTHS = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");

    /**
    * To check email is valid or not
    */
    static getFirebaseTimestamp() {
        var _date = new Date();
        return new firebase.firestore.Timestamp(parseInt(_date.getTime() / 1000), _date.getMilliseconds());
    }
    
    /**
    * To check email is valid or not
    */
    static isValidEmail(email) {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
    }

    static isValidURL(str) {
        var res = str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        if (res == null)
            return false;
        else
            return true;
    }
    
    /**
    * To check is object null or not
    */
    static isNullOrUndefined(object) {
        return (typeof object === 'undefined' || object === null || object === '');
    }
    
    /**
    * To check is array is null or empty
    */
    static isEmpty(arr) {
        return (arr === null || arr.length <= 0);
    }

    /**
    * To Generate unique UUID
    */
    static generateUUID() {
        var d = new Date().getTime()
        var uuid = 'xxxxxxxx-4xxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
    }

    /**
    * To Encrypt Hash
    */
    static encryptString(str, UUID) {
        var _hash = CryptoJS.AES.encrypt(str, CONSTANT.SECRET_KEY + UUID);
        return ""+_hash;
    }
    
    /**
    * To Decrypt Hash
    */
    static decryptString(ciphertext, UUID) {
        var bytes  = CryptoJS.AES.decrypt(ciphertext, CONSTANT.SECRET_KEY + UUID);
        var _plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return ""+_plaintext;
    }

    /**
     * To Formate Date MMDDYYYYYY
     */
    static formatMMDDYYYYDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${month}/${day}/${year}`
    }

    /**
    * To Formate Date MMDDYYYYYY
    */
    static parseMMDDYYDate(date) {
        if (!date) return null;

        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    /**
    * To Formate Date MMDDYYYY
    */
    static getMMDDYYYYDateByDate(date) {
        if (!date){
            date = new Date();
        }
        return ((date.getMonth()) + 1).toString().padStart(2, '0') + "/" + date.getDate().toString().padStart(2, '0') + '/' + date.getFullYear();
    }
    
    /**
    * To Formate Date YYYYMMDD
    */
    static getYYYYMMDDDateByDate(date) {
        if (!date){
            date = new Date();
        }
        return date.getFullYear() + '-' +((date.getMonth()) + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
    }

    /**
    * To Get Full Formated Date
    */
    static getFullFormatedDate(date) {
        if (!date) return "";

        var _DATE = new Date(date);
        
        var day  = this.WEEKS[_DATE.getDay()];
        var dd   = this.dateOrdinal(_DATE.getDate());
        var mm   = this.MONTHS[_DATE.getMonth()];
        var yyyy = _DATE.getFullYear();

        if(dd<10)  { dd='0'+dd } 
        if(mm<10)  { mm='0'+mm } 

        return day+', '+mm+' '+dd+', '+yyyy;
    }
    
    /**
    * To Get Full Formated Date with time
    */
    static getFullFormatedDateWithTime(date) {
        if (!date) return "";

        var _DATE = new Date(date);
         
        var utcDate = new Date(_DATE.toUTCString());

        var day  = this.WEEKS[utcDate.getDay()];
        var dd   = this.dateOrdinal(utcDate.getDate());
        var mm   = this.MONTHS[utcDate.getMonth()];
        var yyyy = utcDate.getFullYear();
        var hh = utcDate.getHours();
            hh = ('0' + hh).slice(-2);
        var min = utcDate.getMinutes();
            min = ('0' + min).slice(-2);


        if(dd<10)  { dd='0'+dd } 
        if(mm<10)  { mm='0'+mm } 

        var _TIME = this.tConvertAMPM(hh+':'+min);

        return day+', '+mm+' '+dd+', '+yyyy+', '+_TIME;
    }
    

    static tConvertAMPM(time) {
        // Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        
        if (time.length > 1) { // If time format correct
          time = time.slice (1);  // Remove full string match value
          time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
          time[0] = ('0' + time[0]).slice(-2);
        }
        return time.join (''); // return adjusted time or original string
    }
    
    /**
    * To Get Full Formated Time
    */
    static getFullFormatedTime(startTimeObj, endTimeObj) {
        if (!startTimeObj || !endTimeObj) return "";
        
        if (typeof startTimeObj === 'object') {
            return startTimeObj.hh+':'+startTimeObj.mm+' '+startTimeObj.A + ' to ' + endTimeObj.hh+':'+endTimeObj.mm+' '+endTimeObj.A;
        } else {
            return startTimeObj + ' to ' + endTimeObj;
        }
    }
    
    /**
    * To Get Timestamp by date
    */
    static getTimestampByDate(date) {
        var now = (date)? new Date(date) : new Date();
        var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return startOfDay / 1000;
    }

    static getDateByTimezone(date){
        var _date = new Date(date);
        var UTCSeconds = (_date.getTime() + _date.getTimezoneOffset()*60*1000);
        return new Date(UTCSeconds);
    }

    /**
    * To Get Date Ordinal
    */
    static dateOrdinal(d) {
        return d+(31==d||21==d||1==d?"st":22==d||2==d?"nd":23==d||3==d?"rd":"th")
    };


    /**
    * To Hours, Minutes, Seconds
    */
    static getHMSByString(string){
        if (typeof string === 'object') {
            return string;
        } else {
            var res = string.split(" "); 
            var res1 = res[0].split(":"); 
            return {
                'A': res[1],
                'hh': ('0' + res1[0]).slice(-2),
                'mm': res1[1]
            }
        }
    }
    
    /**
    * To Get UTC Date
    */
    static getUTCDate(date){
        if(date){
            date = new Date();
        }
         
        var utcDateString = new Date(date.toUTCString()).toISOString();
        return utcDateString;
    }

    /**
    * To Get Age by DOB
    */
    static getAgeByDate(dob){
        if(!dob){
            return "";
        }
         
        var birthday = new Date(dob);
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    /**
    * To get full formatted date
    */
    static getFullDateTimeFormatted(date, time){
        var _date = new Date(date);
        var _time = this.tConvertHHMMSS(time);
        return (_date.getFullYear()) + '-' + (('0' + parseInt(_date.getMonth() + 1)).slice(-2)) + '-' + (('0' + _date.getDate()).slice(-2)) + 'T' + _time + '.000Z';
    }

    /**
    * To get dates array by start and endDate
    */
    static getDatesArray(start, end) {
        var arr = new Array(),
            dt = new Date(start);

        while (dt <= end) {
            var d = new Date(dt);
            arr.push(d);
            dt.setDate(dt.getDate() + 1);
        }
        return arr;
    }

    /**
    * To get week day name by date
    */
    static getWeekDayNameByDate(dt){
        var d = new Date(dt);
        return this.WEEKS[d.getDay()];
    }

    /**
    * To get week number by date
    */
    static getWeekNoByDate(now) {
        var year = this.y2k(now.getYear());
        var month = now.getMonth();
        var day = now.getDate();

        var when = new Date(year,month,day);
        var newYear = new Date(year,0,1);
        var offset = 7 + 1 - newYear.getDay();
        if (offset == 8) offset = 1;
        var daynum = ((Date.UTC(this.y2k(year),when.getMonth(),when.getDate(),0,0,0) - Date.UTC(this.y2k(year),0,1,0,0,0)) /1000/60/60/24) + 1;
        var weeknum = Math.floor((daynum-offset+7)/7);
        if (weeknum == 0) {
            year--;
            var prevNewYear = new Date(year,0,1);
            var prevOffset = 7 + 1 - prevNewYear.getDay();
            if (prevOffset == 2 || prevOffset == 8) weeknum = 53; else weeknum = 52;
        }
        return (weeknum);
    }

    static y2k(number) { return (number < 1000) ? number + 1900 : number; }

    /**
    * To Convert HH,MM,SS to formatted.
    */
    static tConvertHHMMSS(time) {
        var res = time.split(" "); 
        var res1 = res[0].split(":"); 

        var hh = res1[0];
        var mm = res1[1];
        
        if(res[1] == 'AM'){
            return ('0' + res1[0]).slice(-2) + ':' + ('0' + mm).slice(-2) + ':' + ('000').slice(-2);
        }else {
            hh = parseInt(hh) + 12;
            return ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2) + ':' + ('000').slice(-2);
        }
    }

    /**
    * To Get monday of week.
    */
    static getMonday(){
        var d = new Date();
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0)? -6:1;
        // return new Date(d.setDate(diff));
        var n = new Date(d.getFullYear(), d.getMonth(), d.getDate() + (-6 - d.getDay()));
        return n;
    }
   
    /**
    * To check number key.
    */
    static isNumberKey(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 
          && (charCode < 48 || charCode > 57))
           return false;

        return true;
    }

    /**
    * To check character only.
    */
    static onlyCharacter ($event) {
        var keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        var v = String.fromCharCode(keyCode);
        var _isValid = !/^[a-zA-Z]*$/g.test(v);
        if (_isValid) {
            $event.preventDefault();
        }
    }
    
    /**
    * To check number key.
    */
    static isFloatKey(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode != 46 && charCode > 31 
          && (charCode < 48 || charCode > 57))
           return false;

        return true;
    }
    
    /**
    * To convert string to time formate.
    */
    static convertStringToTime(str) {
        var _arr = str.split(' ');
        if(_arr.length == 2){
            var split1 = _arr[0].split(':');
            var _AMPM = (_arr[1] == 'a' || _arr[1] == 'A')? 'AM' : 'PM';
            split1[0] = (!split1[0] || split1[0] < 0 || split1[0] > 12)? "" : (("0" + (split1[0])).slice(-2));
            split1[1] = (!split1[1] || split1[1] < 0 || split1[1] > 60)? "" : (("0" + (split1[1])).slice(-2));
            var time =  split1[0] + ':' + split1[1] + ' ' + _AMPM;
            return (split1[0] && split1[1])? time : "";
        } 
        return "";
    }

    /*
    * Method to check that logs can show or not
    */
    static canShowLogs(role){
        var ALLOW_ROLES = [ 'owner', 'admin', 'office'];
        return (role && ALLOW_ROLES.indexOf(role) > -1)
    }
    
    /*
    * Method to check value is float or not
    */
    static isFloatOrInt(n) {
        return (!isNaN(n) && n.toString().match(/^-?\d*(\.\d+)?$/));
    }
    
    /*
    * Method to generate random numbers by lenth
    */
    static generateRandomByInteger(length) {
        return Math.floor(Math.pow(10, length-1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length-1) - 1));
    }

    /*
    * Method to get short details of user object
    */
    static getShortUserDetail(_USER) {
        return {
            email: _USER.email,
            referCode: "",
            referenceCode: "",
            registrationDate: "",
            showTutorial: true,
            subscription: "basic",
            role: "basic",
            userCurrentEmail: "",
            userId: _USER.uid
        }
    }
    
}
